import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { usePermissions, useRefreshSession } from '@data/hooks';
import { useAppUserStore } from '@data/storage';
import { getUserPanelPermissions } from '@data/utils/helpers';
import PanelLanding from '../PanelLanding';

const PanelsAccessLayout = () => {
  const { PANEL_WRITE, PANEL_FUNNEL } = getUserPanelPermissions();

  const { IS_ADMIN } = usePermissions();
  const { user } = useAppUserStore();
  const { mutate: refreshSession } = useRefreshSession();

  useEffect(() => {
    if (!IS_ADMIN && user?.refreshToken) {
      // to immediately see changes in panel permissions - refresh token on page open
      refreshSession({ refreshToken: user.refreshToken });
    }
  }, []);

  const hasPanelAccess = IS_ADMIN || PANEL_WRITE || PANEL_FUNNEL;

  if (!hasPanelAccess) {
    return <PanelLanding />;
  }

  return <Outlet />;
};

export default PanelsAccessLayout;
